(function () {
    'use strict';
    angular
        .module('corePRUGAGreatApp')
        .constant('CONST_COMMON', {
        	'CAPTCHA_ERROR': 'Vui lòng kiểm tra thông tin mã xác nhận.',
            'AUTHENTICATION_ERROR':'Đăng nhập thất bại! Vui lòng kiểm tra thông tin đăng nhập.'
        })
        .constant('FORMAT_DATE', 'dd/MM/yyyy')
        .constant('FORMAT_DATE_TIME', 'dd/MM/yyyy HH:mm:ss')
        .constant('GLOBAL_STATE', {
			'login': 'login',
			'myTask': 'my-task',
			'commonTask': 'common-task'
		})
		.constant('CLAIM', {
			'CLAIM_STAGE':
				{
				'Registration':'Ðang thẩm định',
				'Confirmation':'Ðang thẩm định',
				'Assessment':'Ðang thẩm định',
				'Approval':'Ðang thẩm định',
				'Closure':'Ðã có quyết định',
				'End':'Ðã có quyết định'
				}
		})
		.constant('WF_TASK', {
			'STATUS':
				{
					'NEW': 'Mới tạo',
					'ASSIGNED' : 'Đã giao'
				},
			'BUS_STATUS':
				{
					'SENT': {
						name :'Đã gửi',
						color :'#ef6502' //cam
					},
					'WAIT_APPROVAL': {
						name :'Đợi duyệt',
						color :'#ef6502' //cam
					},
					'WAIT_PROCESS': {
						name :'Đợi xử lý',
						color :'#ef6502' //cam
					},
					'WAIT_PAY': {
						name :'Đợi chi',
						color :'#ef6502' //cam
					},
					'WAIT_ACCOUNTING_CHECK': {
						name :'Đợi kiểm chứng từ',
						color :'#ef6502' //cam
					},
					'RECEIVED_REQUEST':{
						name :'Nhận yêu cầu',
						color :'#70ed36' //xanh la
					},
					'APPROVAL': {
						name :'Đang duyệt',
						color :'#70ed36' //xanh la
					},
					'PROCESSING': {
						name :'Đang xử lý',
						color :'#70ed36' //xanh la
					},
					'PAYING':{
						name :'Đang chi',
						color :'#70ed36' //xanh la
					},
					'ERROR': {
						name :'Lỗi',
						color :'#ed8e8e' //do
					},
					'CANCELED': {
						name :'Đã hủy',
						color :'#7a6c6c' //xam
					},
					'ERROR_PAY':{
						name :'Lỗi chi',
						color :'#ed8e8e' //do
					},
					'ERROR_VER':{
						name :'Lỗi giới hạn quyền',
						color :'#ed8e8e' //do
					},
					'ERROR_APPROVAL':{
						name :'Lỗi duyệt',
						color :'#ed8e8e' //do
					},
					'SUCCESS':{
						name :'Hoàn tất',
						color :'#0000ff' //xanh duong
					},
					'FINISH':{
						name :'Hoàn tất xử lý',
						color :'#7a6c6c' //xam
					},
					'WAIT_LIFE':{
						name : 'Hệ thống đang xử lý',
						color :'#70ed36' //xanh la
					},
					'ERROR_CANCEL':{
						name :'Lỗi hủy giao dịch',
						color :'#ed8e8e' //do
					},
					'SUCCESS_OPINION':{
						name :'Hoàn tất',
						color :'#0000ff' //do
					}
				}
		})
		.constant('TRANSACTION_TYPE', [
			{
				code: '100',
				name: 'Thu phí hồ sơ mới',
				enable: true
			},
			{
				code: '200', 
				name: ' Thu phí & hoàn trả HĐ',
				enable: true
			},			
			{
				code: '300', 
				name: 'Tạo hợp đồng dự thảo',
				enable: true
			},
			{
				code: '400', 
				name: 'Kiểm tra chứng từ chi trả',
				enable: false
			},
			{
				code: '500', 
				name: 'Chi trả',
				enable: true
			},
			{
				code: '600', 
				name: 'Đăng ký giải quyết QLBH',
				enable: true
			},			
			{
				code: '610', 
				name: 'Bổ sung thông tin QLBH',
				enable: true
			},
			{
				code: '700', 
				name: 'Yêu cầu/ Ý kiến',
				enable: true
			},
			{
				code: '800', 
				name: 'Thay đổi thông tin liên hệ hợp đồng',
				enable: true
			},
			{
				code: '900', 
				name: 'Điều chỉnh/ bổ sung người thụ hưởng',
				enable: true
			},
			{
				code: '1000', 
				name: 'Điều chỉnh định kỳ đóng phí',
				enable: true
			},
			{
				code: '1100', 
				name: 'Điều chỉnh chi tiết nhân thân',
				enable: true
			},
			{
				code: '1200', 
				name: 'Quan hệ nhân thân (retention)',
				enable: true
			},
			{
				code: '1300', 
				name: 'Cứu hủy hợp đồng (retention)',
				enable: true
			}
		])
		.constant('EVENT', {
			'changeOffice': 'CHANGE_OFFICE'
		})
		
        .constant('LDAP_MSG', {
        	ERROR: {
        		"msg.time.before.expiration": "Tài khoản còn {0} ngày, {1} giờ, {2} phút nữa hết hạn!"
        	}
        })
        .constant('FILE_UPLOAD_ALLOW','.pdf')
        .constant('MASTER_CONST',{
        	'EXPORT': 'Xuất danh sách',
            'NEW': 'Tạo mới'
        })
        .constant('LIST_LAYOUT', [
			{
				name: 'warehousingBuyGoods',
				type: 1
			},
			{
				name: 'createWarehousingBuyGoods',
				type: 1
			}
		])
        ;
		
})();